import React, { PureComponent, memo } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { Notificacion } from '../../components/Util/Notificacion/Notificacion';
import { SiteRutas } from '../../request/RutasConfig';
import DetalleEncabezado from '../../components/Body/CallCenterMonitor/DetalleOrden/DetalleEncabezado/DetalleEncabezado';
import DetalleArticulos from '../../components/Body/CallCenterMonitor/DetalleOrden/DetalleArticulos/DetalleArticulos';
import GridMovimientos from '../../components/Body/CallCenterMonitor/DetalleOrden/GridMovimientos/GridMovimientos';
import ProgressBar from '../../components/Body/CallCenterMonitor/DetalleOrden/ProgressBar/ProgressBar';
import { Obtener_Detalles_Orden_Request } from '../../request/CallCenterMonitorRequest';

class DetallesOrdenPage extends PureComponent {
    _isMounted = false;
    state = {
        ordenId: 0,
        detalles: [],
        total: 0,
        esEcommerce: false,
        mostrarArticulos: false,
        detalleSucursal: 0,
        tituloDetalle: '',
        tiemposDetalle: {
            Orden: '',
            Despacho: '',
            Factura: '',
            Ruta: ''
        },
        tab: '0'
    }

    componentDidMount() {
        this._isMounted = true;
        if (this.existenParametros() && this.props.location.state) {
            const parametros = { ...this.props.location.state };
            if (parametros && parametros.ordenId && parametros.total) {
                this.setState({ esEcommerce: parametros.esEcommerce, ordenId: parametros.ordenId, total: parametros.total, tab: parametros.tab }, () => {
                    this.obtenerDetallesOrden();
                });
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.stopInterval();
    }

    obtenerDetallesOrden = async () => {
        if (this.props.token) {
            this.stopInterval();
            this.startInterval();
            const response = await Obtener_Detalles_Orden_Request(this.props.token, this.props.empresa.Id, this.props.callCenter.Id, this.state.esEcommerce, this.state.ordenId);
            if (response.Exitoso) {
                this._isMounted && this.setState({ detalles: response.Datos });
            }
            else {
                if (response.CodigoError === 2) {
                    Notificacion.error("La sesión ha expirado o no tiene permisos para acceder a esta acción o pantalla.");
                    this.props.history.replace(SiteRutas.Login);
                    return false;
                }

                Notificacion.error(response.Mensaje);
            }
        }
    }

    existenParametros = () => {
        return this.props.empresa && this.props.empresa.Id && this.props.callCenter && this.props.callCenter.Id;
    }

    startInterval() {
        this.timer = setInterval(() => {
            this.obtenerDetallesOrden();
        }, 60000);
    }

    stopInterval() {
        if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
        }
    }

    onClickBack = () => {
        this.props.history.push({ pathname: SiteRutas.MonitorCallCenter, state: { tab: this.state.tab } });
    }

    onClickInfoArticulosHandler = () => {
        if (this.state.mostrarArticulos) {
            this.setState({ mostrarArticulos: false });
        }
        else {
            const tiempos = {
                Orden: '',
                Despacho: '',
                Factura: '',
                Ruta: ''
            }
            this.setState({ mostrarArticulos: true, detalleSucursal: 0, tituloDetalle: "Detalles Generales", tiemposDetalle: tiempos });
        }
    }

    onClickMovimientoHandler = (pSucursalId, pSucursalNombre, pTiempos) => {
        if (pSucursalId !== 0) {
            this.setState({ mostrarArticulos: true, detalleSucursal: pSucursalId, tituloDetalle: pSucursalNombre, tiemposDetalle: pTiempos });
        }
        else {
            this.onClickInfoArticulosHandler();
        }
    }

    render() {
        if (!this.existenParametros() || !this.state.detalles || this.state.detalles.length === 0) {
            return null;
        }

        let tab = "";
        switch (this.state.tab) {
            case "0":
                tab = " - Pendiente";
                break;
            case "1":
                tab = " - En Ruta";
                break;
            case "2":
                tab = " - Terminada";
                break;
            case "3":
                tab = " - Por Estado";
                break;
        }

        return (
            <section className="padding-ordenes">
                <div className="row no-gutters">
                    <div className="col-12 mt-4">
                        <h4 onClick={this.onClickBack} className="pointer"><FontAwesomeIcon icon={faArrowLeft} /> Datos de Orden{tab}</h4>
                    </div>
                    <div className="col-12">
                        <DetalleEncabezado orden={this.state.detalles[0]} total={this.state.total} esEcommerce={this.state.esEcommerce} />
                        <div className="row">
                            <div className="col-sm-12 col-lg-2">
                                <ProgressBar tiempos={this.state.tiemposDetalle} />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-10">
                                <GridMovimientos movimientos={this.state.detalles} onClick={this.onClickMovimientoHandler} />
                            </div>
                            <div>
                                <div className={"items " + (this.state.mostrarArticulos ? "show" : "")}>
                                    <DetalleArticulos
                                        titulo={this.state.tituloDetalle}
                                        ordenGrupo={this.state.ordenId}
                                        sucursalId={this.state.detalleSucursal}
                                        esEcommerce={this.state.esEcommerce}
                                        onClick={this.onClickInfoArticulosHandler} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        empresa: state.parametros.empresa,
        callCenter: state.parametros.callCenter
    };
};

export default connect(mapStateToProps)(withRouter(memo(DetallesOrdenPage)));